module.exports = __webpack_public_path__ + "img/banner.e6999d8a.png";